module.exports = " <div class=app> <ui-view></ui-view> </div> ";


//////////////////
// WEBPACK FOOTER
// ./client/app/app.html
// module id = 599
// module chunks = 0